import request from 'superagent'
import types from '../types'
import Authorization from '../../types/Authorization'
import OrganizationDetail from '../../types/OrganizationDetail'

import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if(api_port==='')
  apiUrl = `${protocol}//${hostname}/api`

const getProviderDetailsRequested = () => ({
  type: types.GET_PROVIDER_DETAIL_REQUESTED,
  payload: null
})

const getProviderDetailsRejected = (error: any) => ({
  type: types.GET_PROVIDER_DETAIL_REJECTED,
  payload: error
})

const getProviderDetailsFulfilled = (data: Array<Authorization>) => ({
  type: types.GET_PROVIDER_DETAIL_FULFILLED,
  payload: data
})

export const getProviderDetails = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getProviderDetailsRequested())
    request
      .get(`${apiUrl}/provider/detail/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getProviderDetailsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getProviderDetailsRejected(error))
      })
  }
}

const getOrgProviderDetailsRequested = () => ({
  type: types.GET_ORG_PROVIDER_DETAIL_REQUESTED,
  payload: null
})

const getOrgProviderDetailsRejected = (error: any) => ({
  type: types.GET_ORG_PROVIDER_DETAIL_REJECTED,
  payload: error
})

const getOrgProviderDetailsFulfilled = (data: Array<Authorization>) => ({
  type: types.GET_ORG_PROVIDER_DETAIL_FULFILLED,
  payload: data
})

export const getOrgProviderDetails = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getOrgProviderDetailsRequested())
    request
      .get(`${apiUrl}/organization/detail/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getOrgProviderDetailsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getOrgProviderDetailsRejected(error))
      })
  }
}

const updateProviderDetailRequested = () => ({
  type: types.UPDATE_PROVIDER_DETAIL_REQUESTED,
  payload: null
})

const updateProviderDetailRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_DETAIL_REJECTED,
  payload: error
})

const updateProviderDetailFulfilled = (data: OrganizationDetail, id: number) => ({
  type: types.UPDATE_PROVIDER_DETAIL_FULFILLED,
  payload: data,
  id,
})

export const updateProviderDetail = (id: number, data: any, token: string) => {
  return (dispatch: any) => {
    dispatch(updateProviderDetailRequested())
    request
      .put(`${apiUrl}/provider/detail/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .send(data)
      .then((response) => {
        dispatch(updateProviderDetailFulfilled(response.body, id))
      })
      .catch((error) => {
        dispatch(updateProviderDetailRejected(error))
      })
  }
}

const getDetailToUpdateRequested = () => ({
  type: types.GET_DETAIL_TO_UPDATE_REQUESTED,
  payload: null
})

const getDetailToUpdateFulfilled = (data: any) => ({
  type: types.GET_DETAIL_TO_UPDATE_FULFILLED,
  payload: data
})

const getDetailToUpdateRejected = (error: any) => ({
  type: types.GET_DETAIL_TO_UPDATE_REJECTED,
  payload: error
})

export const getDetailToUpdate = (id: number, eid: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getDetailToUpdateRequested())
    request
      .post(`${apiUrl}/organization/detailToUpdate/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send({ eid })
      .then((response) => {
        dispatch(getDetailToUpdateFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getDetailToUpdateRejected(error))
      })
  }
}
